import { useEffect } from "react";
import { useTenant } from "../Contexts/TenantContext";

const SEOManager = () => {
    const { tenantData } = useTenant();


    useEffect(() => {
        
const seo = tenantData?.seo || {};
        const brandName = tenantData?.branding?.brandName || "";

document.title = seo.metaTitle
    ? brandName
        ? `${seo.metaTitle} | ${brandName}`
        : seo.metaTitle
    : brandName || "Travel Website";

        const updateMetaTag = (name, content) => {
            let tag = document.querySelector(`meta[name="${name}"]`);

            if (!tag) {
                tag = document.createElement("meta");
                tag.setAttribute("name", name);
                document.head.appendChild(tag);
            }

            tag.setAttribute("content", content || "");
        };

        updateMetaTag("description", seo.metaDescription);
        updateMetaTag("keywords", seo.metaKeywords);
    }, [tenantData]);

    return null;
};

export default SEOManager;